module.exports = __webpack_public_path__ + "img/astrottica_p.82063e4c.jpg";